export enum LocalDevDefaultOverrideMode {
    RetainOriginal,
    ApplyOverride
}
